import postMessageToParent from './postMessageToParent';

export default function postImageRejectedMessage(payload: any) {
  postMessageToParent({
    message: 'image_rejected',
    id: '',
    payload
  });
}
